import useHNConverter from '../hooks/DataConverter/useHNConverter/useHNConverter'

// HN เก็บในฐานข้อมูลเป็นเลขติดกัน (660028318) แต่เจ้าหน้าที่ใช้รูปแบบ 28318/66
// ใช้ตัวแปลงตัวเดียวกับที่ PatientRegistrationList และ Airdoc ใช้ เพื่อให้ HN
// ของผู้ป่วยคนเดียวกันแสดงเหมือนกันทั้งพอร์ทัล
export const formatHn = (hn) => {
  const raw = String(hn === 0 || hn ? hn : '').trim()
  if (!raw) {
    return ''
  }
  return useHNConverter(raw).convertHN()
}

// รับได้ทั้ง 28318/66 และ 660028318 แล้วคืนรูปแบบที่ใช้ค้นในฐานข้อมูล
// ถ้ารูปแบบไม่ครบ (เช่น "28318/" หรือ "/66") คืนค่าเดิมไป ให้การค้นหาไม่เจอไปเลย
// ดีกว่าเดาแล้วยิง HN ผิดคนไปค้น
export const toRawHn = (value) => {
  const input = String(value || '').trim()
  if (!input.includes('/')) {
    return input
  }
  const [runningNumber, year] = input.split('/')
  if (!runningNumber || !year) {
    return input
  }
  return useHNConverter(input).revertHN()
}
